export const STAT_TYPE_ATTRS = {
  views: "impressions",
  clicks: "clicks",
  plays: "videoStarts"
};

export const STAT_TYPE_LABELS = {
  views: "Views",
  clicks: "Clicks",
  plays: "Plays"
};

export const STAT_TYPE_QUESTIONS = {
  views: "How many times has your ad been viewed?",
  clicks: "How many times has your ad been clicked?",
  plays: "How many times has your ad been played?"
};

export const CTV_STAT_TYPE_QUESTIONS = {
  views: "How many times has your commercial been viewed?",
  clicks: "How many times has your commercial been clicked?",
  plays: "How many times has your commercial been played?"
};
